// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Data Mall",
        "pull_refresh": "Stáhnout dolů a obnovit",
        "release_refresh": "Uvolněte se k obnovení",
        "refresh_loading": "Načítání ...",
        "footer_text": "Služby poskytuje společnost Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Hledat zemi/region",
        "my_flow": "Moje data",
        "charge_code": "Kód voucheru",
        "coupons": "Kupóny",
        "local_package": "Místní data",
        "more": "Více",
        "popular_destination": "Země/region",
        "buy_now": "Koupit hned",
        "package_useing": "Aktivní",
        "unused": "Neaktivní",
        "download_app": "Stáhnout aplikaci",
        "enter_the_mall_list": "Přejít do obchoďáku",
        "no_data": "Zatím žádná data",
        "no_data_available": "Nejsou k dispozici žádná data",
        "copy_success": "Kopírování úspěšné",
        "copy_fail": "Kopírování selhalo",
        "meritsTitle": "Jaké jsou výhody?",
        "merits1": "Bez SIM karty & Bez měsíčních poplatků",
        "merits2": "Integrováno s topovými 2-3 operátory pro automatické přepínání sítě",
        "go_buy": "Jít koupit",
        "instant_savings": "Ušetři",
        "expires_in": "Vyprší za",
        "download_app_tips": "Stáhněte aplikaci pro více nabídek a zážitků"
    },
    "packages": {
        "sub_title": {
            "us": "S výjimkou Guamu, Saipane",
            "it": "Včetně Vatikánu, San Marino",
            "va": "Včetně Itálie, San Marino",
            "sm": "Včetně Itálie, Vatikánského města",
            "ma": "Včetně západní Sahary",
            "eh": "Včetně Maroka",
            "ch": "Včetně Liechtensteinu",
            "li": "Včetně Švýcarska",
            "fr": "Včetně Monako",
            "mc": "Včetně Francie",
            "fi": "Včetně Alandských ostrovů",
            "ax": "Včetně Finska",
            "gu": "Včetně ostrovů ze severní Mariany",
            "mp": "Včetně Guamu"
        },
        "unlimited_packages": "Neomezený datový balíček",
        "normal_packages": "Normální datový balíček",
        "multi_region_packages": "Multi-Region",
        "regional_data": "Regionální data",
        "high_speed_text": "Vysokorychlostní data",
        "infiniteFlow": "Neomezená data",
        "unLimitData": "Neomezený",
        "high_speed_text_year": "Vysoká rychlost/MP",
        "package_list": "Seznam balíčků",
        "special_offer": "Slevy",
        "first_month": "1. Měsíc",
        "periodUnit": {
            "day": "den (S)",
            "month": "měsíc",
            "hour": "hodina",
            "year": "rok"
        },
        "periodUnits": {
            "day": "den (S)",
            "month": "měsíce",
            "hour": "hodina",
            "year": "roky"
        },
        "periodUnitSimp": {
            "day": "d",
            "month": "pro",
            "hour": "h",
            "year": "the"
        },
        "periodUnitMonthly":"Měsíční",
        "periodUnitsSimp": {
            "day": "d",
            "month": "pro",
            "hour": "h",
            "year": "the"
        },
        "unlimited_good_name": {
            "day": "Denní průchod",
            "month": "Měsíčná jízdenka",
            "year": "Roční průchod"
        },
        "continuousMonth": "Nepřetržité měsíce",
        "continuousDay": "Nepřetržité dny",
        "continuousYear": "Nepřetržité roky",
        "day_invalid": "Vypršet v aktuální den",
        "month_invalid": "Vyprší v aktuálním měsíci",
        "immediate_valid": "Efektivní okamžitě",
        "tomorrow_day_valid": "Efektivní od příštího dne",
        "tomorrow_month_valid": "Efektivní od příštího měsíce",
        "detail": {
            "cell_flow": "Data",
            "cell_period": "Platnost",
            "buy_quantity": "Množství",
            "use_area": "Krytí",
            "use_intro": "Smluvní podmínky",
            "buy_btn": "Objednávka",
            "pay": "platit",
            "buy_tips": "Máte balíček %@packageName v užití. Chcete koupit tento balíček?",
            "haveOrderTips": "Vytvořen objednávka s čekající platbou. Klikněte Potvrdit pro přechod na mou datovou stránku！"
        },
        "confirm": {
            "title": "Potvrzení objednávky",
            "real_pay_amount": "Zaplacená částka",
            "online_payment": "Online platba",
            "create_order_error": "Nastavení selhalo"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Získání stavu objednávky…",
            "buy_success": "Objednávka dokončena",
            "buy_pending": "Čekající potvrzení",
            "buy_pending_tip": "Platba v procesu ... Pokud se platba nedostává do 10 minut, kontaktujte nás pro podporu.",
            "get_payment_info_fail": "Získání informací o platbách selhalo",
            "cell_package": "Balík",
            "cell_buy_amount": "Subtotál",
            "cell_real_amount": "Zaplacená částka",
            "go_to_order_btn": "Přejít na můj balíček",
            "back_home": "Zpět domů",
            "back_mall": "Zpět do obchoďáku",
            "ordersn_empty": "Objednejte SN nemůže být prázdný",
            "order_search_error": "Neočekávaná chyba",
            "goodsName": 'Název produktu'
        },
        "fail": {
            "payment_fail": "Platba selhala",
            "back_home": "Zpět domů"
        }
    },
    "CountryGroup": {
        "title": "Země/region",
        "placeholder": "Hledat zemi nebo region",
        "clear": "Jasný",
        "history": "Historie vyhledávání"
    },
    "PromotionCode": {
        "verification": {
            "title": "Kód voucheru",
            "minititle": "Kód voucheru",
            "input": "Zadejte prosím doplňkový kód",
            "explain": "Tipy: Dotkněte se tlačítka skenování v pravém horním právu na skenování QR kódu karty voucheru nebo ručně zadejte kód voucheru (pouzdro citlivý), pokud to nefunguje.",
            "submit": "Předložit",
            "exchange": "Vykoupit",
            "cancel": "Zrušit",
            "Inquiry": "Určitě si vyměňujete",
            "ErrorCode": "Dobijte chybu kódu"
        },
        "recharge_success": {
            "package": "Balík",
            "content": "Úspěšně vykoupeno",
            "back": "Zpět do nákupního centra",
            "view_packets": "Přejít na můj balíček"
        }
    },
    "order": {
        "state": {
            "inUse": "Aktivováno",
            "isFirst": "Upřednostňována",
            "toFirst": "Stanovit prioritu",
            "inactive": "Inaktivovaný"
        },
        "periodUnits": {
            "minute": "zápis)",
            "hour": "hodina",
            "day": "den (S)",
            "month": "Měsíc"
        },
        "useIntro": {
            "tip1": "Neomezený balíček dat má vyšší prioritu než objem datový balíček.",
            "tip2": "Priorita využití bude založena na datu nákupu pro stejný typ balíčku, tj. Balíček s nejranějším datem nákupu bude použit nejprve, zatímco priorita balíčků s jedním regionem je vyšší než regionální balíček.",
            "tip3": "Prioritu používání paketů stejného typu můžete také ručně upravit."
        },
        "myFlow": "Moje data",
        "remainingFlow": "Zbývající data",
        "remainingTime": "Platné vlevo",
        "remainingHighFlow": "Zbývá vysokorychlostní data",
        "validPeriod": "Platnost",
        "noneFlow": "Žádný datový balíček",
        "noneFlowTip": "Zakupte si datový balíček a užijte si vysoce kvalitní síť",
        "buyPackFlow": "Koupit balíčky",
        "checkInvalidFlow": "Zkontrolujte balíček pro vypršení platnosti datu",
        "orderList": {
            "title": "moje rozkazy",
            "amount_paid": "Celkový",
            "device": "Vlastní zařízení",
            "order_details": "Podrobnosti objednávky",
            "total_amont": "Mezisoučet",
            "orderSN": "Obj.č.",
            "createTime": "Čas vytvoření",
            "cancelTime": "Zavřená doba",
            "payTime": "Čas objednávky",
            "unsubTime": "Zrušený čas",
            "payMethod": "Způsob platby",
            "thirdSN": "Transakce č.",
            "delete": "Vymazat",
            "cancel": "Zrušit objednávku",
            "unsub": "Vrácení peněz",
            "goto_cancel": "Chcete objednávku zrušit?",
            "goto_unsubscribe": "Chcete zrušit odběr objednávky?",
            "delete_Tips": "Objednávku nelze po smazání obnovit, proto nelze vyřešit vaše pozáruční problémy.Opravdu to chcete smazat?",
            "status_success": "Dokončeno",
            "status_pending": "Nezaplaceno",
            "status_cancel": "ZAVŘENO",
            "status_unsub": "Zrušeno",
            "payMethod_stripe": "Kreditní karta"
          },
    },
    "registerlogin": {
        "create_account_tip":"Vytvořte si účet, začněte exkluzivní zážitek",
        "select_country_tip":"Zařízení používat zemi/region",
        "email_name": "E -mail",
        "phone_name": "Telefon",
        "email_address": "E-mailová adresa",
        "password": "heslo",
        "country": "země",
        "select_country": "Vyberte si zemi",
        "cancel": "Zrušit",
        "confirm": "Jistě",
        "please_enter": "Zadejte prosím 6-20 znaků (kombinace písmen, čísel nebo symbolů)",
        "select_country_tips": "Výběr země je pro prohlížení místních balíčků. Po registraci to nelze změnit. Potvrďte!",
        "global_roaming": "Mezinárodní kód domény",
        "phone_number": "telefonní číslo",
        "agree": "souhlasit",
        "user_agreement": "Uživatelská dohoda",
        "and": "a",
        "privacy_policy": "Zásady ochrany osobních údajů",
        "register_login": "Zaregistrujte se nebo se přihlaste",
        "login_error": "Počet přihlášení je příliš častý, zkuste to znovu později!",
        "register_error": "Počet registrací je příliš častý, zkuste to znovu později!",
        "forgot_pwd": "Zapomeňte na heslo",
        "app_tips": "Po stahování se přihlaste k aplikaci s tímto účtem a získejte přístup k dalšímu funkcím.",
        "download_app": "Přejděte ke stažení aplikace",
        "rememberPwd": "Pamatujte heslo",
        "third_login": "Pokračujte s",
        "agreement_tips": "Zkontrolujte prosím políčko Uživatelské smlouvy a zásady ochrany osobních údajů",
        "selectCountry_tips": "Všimněte si, že registrovaná země bude přímo ovlivnit následující metody a měny plateb, vyberte prosím podle vaší potřeby.",
        "login_error_cancel": "Uživatel zrušil přihlášení",
        "login_error_auth": "Povolte vyskakovací okna v nastaveních prohlížeče",
        "device_tips": "Zařízení čeká na aktivaci. Zpracování do 24 hodin."
    },
    "forgotPwd": {
        "forgot_pwd": "Zapomeňte na heslo",
        "email_address": "E-mailová adresa",
        "next": "Další",
        "email_has_been_sent": "Poslali jsme e -mail na %@email. Klikněte na odkaz a postupujte podle kroků a načtete heslo.",
        "have_retrieved_it": "Našel jsem to",
        "unable_to_receive_email": "Nemůžete obdržet e -mail? Zkontrolujte, zda jsou e -maily z %@email pod vaším spamem a smazanou poštovní adresář",
        "or": "nebo",
        "resend": "Odeslat",
        "global_roaming": "Mezinárodní kód domény",
        "phone_number": "telefonní číslo",
        "verification_code_has_been_sent": "Ověřovací kód jsme poslali na:",
        "verification_code": "Ověřovací kód",
        "no_verification_code_received": "Nedostali jste ověřovací kód?",
        "please_enter": "Zadejte prosím 6-20 znaků (kombinace písmen, čísel nebo symbolů)",
        "reset_password": "Resetovat heslo",
        "reset_successful": "Resetujte úspěšně"
    },
    "coupons": {
        "coupons_name": "Kupóny",
        "no_coupons": "Zatím žádné kupóny",
        "no_data": "Zatím žádná data",
        "applicable_to_the_following": "Kupóny jsou vhodné pro následující datový balíček"
    },
    "digital":{
        "title":"Zařízení SN",
        "purchased":"Moje nákupy",
        "viewAll":"Více",
        "skinStore":"Obchod s produktem",
        "completed":"Zakoupené",
        "goBuy":"Nakoupit",
        "order": {
          "title":"Zakoupené objednávky"
        },
        "detail": {
          "describe":"Popis"
        }
    },
    "viewPL": {
        "other": 'ostatní'
    },
    "invalidFlow": {
        "stateName": "Postavení",
        "state": {
            "NOT_ACTIVATED": "Inaktivovaný",
            "IN_USING": "K dispozici",
            "USE_END": "Vyčerpaný",
            "EXPIRE": "Vypršel",
            "TRANSFER": "Převod",
            "UNSUBSCRIBE": "Zrušit",
            "VALID": "Platný",
            "INVALID": "Neplatný",
            "EXCHANGE_POINTS": "Vykoupit body"
        },
        "noneFlow": "Žádný balíček pro vypršení platnosti datu",
        "pageName": "Vypršený datový balíček"
    },
    "flowDetail": {
        "title": "Údaje o údajích",
        "flow": "Data",
        "validTime": "Platné začátek",
        "invalidTime": "Platné do",
        "coverage": "Krytí",
        "useIntro": "Smluvní podmínky",
        "purchaseTime": "Zakoupeno na",
        "subtotal": "Subtotál",
        "status": "Postavení",
        "cancel": "Zrušit",
        "buyAgain": "Koupit to znovu",
        "validity": "Platnost",
        "tip": "Oznámení",
        "cancelTip": "Jste si jisti, že chcete tento balíček vrátit?",
        "dataLeft": "Zbývající data"
    },
    "netError": {
        "try_again": "Zkuste to znovu",
        "net_error": "Žádná síť",
        "try_again_desc": "Zkontrolujte prosím nastavení sítě a zkuste to znovu"
    },
    "loadFail": {
        "try_again": "Zkuste to znovu",
        "load_fail": "Načítání selhalo",
        "load_fail_desc": "Načítání dat selhalo, zkuste to prosím znovu",
        "IMEI_Not_Exist": "IMEI neexistuje, zkuste prosím vstoupit ze správného vchodu",
        "Project_Not_Exist": "Dojde k chybě. Kontaktujte prosím zákaznický servis. (01)",
        "commonError": "Dojde k chybě. Kontaktujte prosím zákaznický servis."
    },
    "settlement_Easy_and_convenient": "Snadné a pohodlné",
    "settlement_Great_deal": "SKVĚLÉ",
    "settlement_Safe_and_secure": "Bezpečné a bezpečné",
    "settlement_Autopay_service_regulation": "Regulace služeb Autopay",
    "settlement_Read": "Číst",
    "settlement_No_coupon": "Žádný dostupný kupón",
    "settlement_Subtotal": "Subtotál",
    "settlement_Coupon": "Kupón",
    "settlement_TOTAL": "Celkový",
    "settlement_promotion_tip": "Propagační nabídku nelze použít ve spojení s žádnými kupony",
    "settlement_coupon_tip": "Kupón nelze použít ve spojení s žádnými jinými propagačními nabídkami",
    "member_myFlow_noList": "Žádná data",
    "detail_se_content": "Bezpečný, snadný a pohodlný způsob. Můžete se odhlásit kdykoli",
    "Enter_Promo_code": "Propagační kód",
    "Enter_Promo_Coupon": "Kupóny",
    "settlement_Not_used_coupon": "kupón se nepoužil",
    "settlement_Available_coupon": "K dispozici",
    "settlement_Unavailable_coupon": "Nedostupné",
    "please_Enter_Promo_code": "Zadejte propagační kód",
    "please_Select_Coupon_use": "Vyberte prosím kupón, který chcete použít.",
    "Buy_Now": "Koupit hned",
    "Dont_Use_Any": "Nepoužívejte žádné",
    "settlement_confirm": "Potvrdit",
    "settlement_tips": "Potvrdit",
    "flowDetail_unsubscribe": "Odhlásit se",
    "flowDetail_unsubscribed": "Odhlášeno",
    "flowDetail_isCancelPackage": "Odhlásit tento balíček?",
    "flowDetail_confirmAgreementUnsubscribe": "Po odhlášení nemůžete mít velké množství. Jste si jisti, že se chcete odhlásit?",
    "flowDetail_cancel": "Zrušit",
    "flowDetail_cancelSuccess": "Odhlásit se úspěšně",
    "packages_detail_promotion": "Podpora",
    "orderTips":{
        "iDay" : "den",
        "iDays" : "dny",
        "iMonth" : "měsíc",
        "iMonths" : "měsíce",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Při prvním nákupu, Zaplaťte %@money/%@periodSymbol později, Můžete se odhlásit kdykoli",
        'Monthly_discount':"Ušetřete %@saveMoney každý %@period! Můžete se odhlásit kdykoli",
        'Ordinary_monthly_package':"Bezpečný, snadný a pohodlný způsob. Můžete se odhlásit kdykoli",
        "AlreadyPurchased":'Omlouváme se, že se v současné době můžete přihlásit pouze k odběru jednoho datového balíčku. Odhlášení z “%@” a později se přihlaste k odběru jakéhokoli balíčku, který si přejete po uplynutí vypršení.',
        "Contract_recommendation_First":'<label>S autopay službou, na vašem prvním nákupu, plaťte pouze</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Můžete se odhlásit kdykoli'
        +'<a class="btn">Upsat ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>S autopay službou, plaťte pouze</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Můžete se odhlásit kdykoli'
        +'<a class="btn">Upsat ></a></p>',
        "Contract_recommendation_General":"<label>Se službou Autopay</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Bezpečný, snadný a pohodlný způsob. Můžete se odhlásit kdykoli'
        +'<a href="javascript:;" class="btn">Upsat ></a></p>',
        'BanlanceDoubleCheck':'Jste si jisti, že chcete platit s zůstatkem?',
    },
    feedback: {
        title: "zpětná vazba",
        placeholder: "Vstupte do země, kterou chcete navštívit, nebo jakékoli jiné otázky, a my splníme vaše potřeby co nejdříve!",
        submit: "Předložit",
        submit_success: "Úspěšně odesláno",
        other_opinions: "Ostatní názory",
    },
    view_country_input: 'Zadejte prosím svůj účet',
    "select_package": {
        "title": "Vybrat Data",
        "allPackage": "Všechna Data",
        "type": "Typ",
        "flow": "Data",
        "month_package": "Měsíční plán",
        "flow_package": "Datový balíček",
        "time": "Trvání",
        "period": "Cykel",
        "auto_debit": "Info Autodebet",
        "auto_subscribe": "Auto-Obnovení",
        "detail": "Podrobnosti Dat",
        "carrier": "Podporované Operátory",
        "country": "Pokryté Země",
        "notice": "Návod na nákup"
    }
}